// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdShareablePreviewPostResult = objectOf({
  shareable_preview_links: arrayOf(
    objectOf({
      app_group_id: string,
      company_id: string,
      context_id: string,
      context_type: string,
      created_at: number,
      id: string,
      expires_at: number,
      s3_link: string,
    })
  ),
});
